/**
 * Resolves a value from a header config map.
 *
 * - When `map` is missing, returns `fallback`.
 * - When `map` is a function, calls it with `(value, item)`.
 * - When `map` is an object, looks up `map[value]` (may be `undefined`,
 *   matching the original cell-component semantics).
 *
 * @param {Object|Function|null|undefined} map
 * @param {*} value
 * @param {Object} item
 * @param {*} [fallback]
 */
export const resolveFromMap = (map, value, item, fallback = null) => {
  if (!map) return fallback
  if (typeof map === 'function') return map(value, item)
  return map[value]
}
